// IE 11 Support
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
// END: IE 11 Support

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Honeybadger, HoneybadgerErrorBoundary } from '@honeybadger-io/react';
import { Auth0Provider } from '@auth0/auth0-react';

import { getEnvironment } from './config/environment';
import { authConfig } from './config/auth';
import AuthApolloProvider from './AuthApolloProvider';
import App from './App';

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    rudderanalytics: any;
    chatCustomerId?: string;
  }
}

const { environment } = getEnvironment();
const { REACT_APP_GIT_SHA } = process.env;

Honeybadger.configure({
  apiKey: '0f8e018b',
  developmentEnvironments: ['development', 'loadtest'],
  environment,
  revision: REACT_APP_GIT_SHA,
  breadcrumbsEnabled: true,
});

const authConfiguration = authConfig();

function ChatApp(): JSX.Element {
  return (
    <HoneybadgerErrorBoundary honeybadger={Honeybadger}>
      <Auth0Provider
        audience={authConfiguration.audience}
        clientId={authConfiguration.clientId}
        domain={authConfiguration.domain}
      >
        <BrowserRouter>
          <AuthApolloProvider>
            <App />
          </AuthApolloProvider>
        </BrowserRouter>
      </Auth0Provider>
    </HoneybadgerErrorBoundary>
  );
}

ReactDOM.render(<ChatApp />, document.getElementById('root'));

export default ChatApp;
